import moment from "moment-timezone";
import { TimezoneOption } from "@core/features/timezones";

export type HeaderFormat = "date" | "weekday";

export type Args = {
  /** ISO date string (e.g., '2025-01-15') */
  dateString: string;
  /** User's selected timezone */
  timezone: TimezoneOption;
  /** Format: 'date' shows "Jan 14 PST", 'weekday' shows "Mon" */
  format?: HeaderFormat;
};

/**
 * Format a date for display in the grid header.
 * - format='date': "Jan 14 PST"
 * - format='weekday': "Mon"
 */
export function formatDateHeader({
  dateString,
  timezone,
  format = "date",
}: Args): string {
  const m = moment.tz(dateString, timezone.name);

  if (format === "weekday") {
    return m.format("ddd"); // "Mon", "Tue", etc.
  }

  // Default: date format with timezone
  const dateFormatted = m.format("MMM D");
  const tzAbbr = m.format("z");

  return `${dateFormatted} ${tzAbbr}`;
}

/**
 * Format multiple dates for grid headers.
 * @param format - 'date' shows "Jan 14 PST", 'weekday' shows "Mon"
 */
export function formatDateHeaders(
  dateStrings: string[],
  timezone: TimezoneOption,
  format: HeaderFormat = "date"
): string[] {
  return dateStrings.map((dateString) =>
    formatDateHeader({ dateString, timezone, format })
  );
}

export default formatDateHeader;

